import {
    SET_USER,
    SET_AUTHENTICATED,
    SET_UNAUTHENTICATED,
    LOADING_USER,
    SET_LOADING,
    STOP_LOADING,
} from '../types';

const initialState = {
    authenticated: false,
    loading: false,
    credentials: {}
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AUTHENTICATED:
            return { ...state, authenticated: true };
        case SET_UNAUTHENTICATED:
            return initialState;
        case SET_USER:
            return { authenticated: true, loading: false, ...action.payload };
        case LOADING_USER:
            return { ...state, loading: true };
        case SET_LOADING:
            return { ...state, loading: true };
        case STOP_LOADING:
            return { ...state, loading: false };
        default:
            return state;
    }
}